var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcErrorQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.4,
    stroke: "#005059",
    strokeWidth: 3.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.1011V27.3122",
    stroke: "#005059",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2224 21.629V20.4226C21.0575 20.4226 21.8739 20.175 22.5683 19.711C23.2626 19.247 23.8038 18.5876 24.1234 17.8161C24.443 17.0445 24.5266 16.1955 24.3637 15.3765C24.2008 14.5574 23.7986 13.805 23.2081 13.2145C22.6176 12.624 21.8652 12.2218 21.0462 12.0589C20.2271 11.896 19.3781 11.9796 18.6066 12.2992C17.835 12.6188 17.1756 13.16 16.7116 13.8544C16.2476 14.5487 16 15.3651 16 16.2002",
    stroke: "#005059",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcErrorQuestion);
export default __webpack_public_path__ + "static/media/ic_ErrorQuestion.37bb51a55125527d776265926a01388a.svg";
export { ForwardRef as ReactComponent };